module.exports = __webpack_public_path__ + "static/media/banner.19750782.png";